import './index.styl';
import TradePlayerPoolListPlayer from '../TradePlayerPoolListPlayer';
import { PlayerPoolList } from '../../index';
import Radio from 'backbone.radio';
import _ from 'lodash';

const
	CHANNEL_STATS = Radio.channel('stats'),
	CHANNEL_TRADE = Radio.channel('trade');

/**
 * @description View with list of players.
 * Should show all player that accepted by filters provided from parent view
 */
export class TradePlayerPoolList extends PlayerPoolList {
	get childView() {
		return TradePlayerPoolListPlayer;
	}

	childViewOptions(model) {
		super.childViewOptions(model);

		model.set({
			is_trade_locked: this.is_trade_locked,
			order_by_column: this.order_by,
			tpl_type: this.tpl_type
		}, { silent: true });
	}

	initialize() {
		super.initialize();

		this.tpl_type = 'base';
		this.order_by = 'stats.avg_points';
		this.is_trade_locked = false;

		this.listenTo(CHANNEL_TRADE, 'data:changed', this.init);
		this.listenTo(CHANNEL_TRADE, 'remove:trade:in:player', this.restorePlayer);
		this.listenTo(CHANNEL_TRADE, 'trade:team:available:positions', this.updateTradeLockState);
		this.listenTo(CHANNEL_STATS, 'change:players:template', this.changeTemplate);
	}

	changeTemplate(tpl_type){
		this.tpl_type = tpl_type;
	}

	onPlayerAdd({ model }) {
		this.collection.remove(model.get('id'));
		CHANNEL_TRADE.trigger('trade:in:player', model.toJSON());
	}

	restorePlayer({ player }) {
		this.collection.add(player);
	}

	get filtersList() {
		return {
			...super.filtersList,
			filter_by_price: function (price_str, model) {
				if (!price_str || Number(price_str) === -1) {
					return true;
				}

				const
					[lowest, highest, by_locked] = price_str.split('-').map(Number),
					player_cost = model.get('cost') / 1000,
					is_cost_in_range = lowest <= player_cost && player_cost <= highest;

				if(!_.isUndefined(by_locked)){
					return (
						is_cost_in_range && !model.get('is_trade_locked') && !model.get('locked')
					);
				}

				return is_cost_in_range;
			}
		}
	}

	updateTradeLockState({ pool: size_of_available_trades_to_team }) {
		const is_trade_locked = !size_of_available_trades_to_team;

		this.is_trade_locked = is_trade_locked;

		this.collection.each(player => {
			const is_locked = parseInt(player.get('locked'), 10);

			if (!is_locked) {
				player.set({ is_trade_locked })
			}
		});

		return this;
	}
}

export default TradePlayerPoolList;